<template>
	<div class="container">
		<div class="container_content">
			<component :is="convertToTitle()?.icon" width="82" height="82" />
			<div class="content_box">
				<h4>{{ category }}</h4>
				<p>
					{{ convertToTitle()?.top_sub }}<br />
					{{ convertToTitle()?.bottom_sub }}
				</p>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { EtfGridData } from '@/constants/menu';

const route = useRoute();
const category = computed(() => String(route.params.category));
const convertToTitle = () => {
	return EtfGridData.find((item) => item.title === category.value);
};
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	align-items: center;
	gap: 1rem;
	width: 100%;
	height: 17rem;
	padding: 1.6rem 2rem;
	background-color: var(--color-bg-mid);
	border-radius: 0.8rem;
	box-shadow: 4px 4px 30px 0px rgba(0, 0, 0, 0.3);
	&_content {
		display: flex;
		align-items: center;
		gap: 1rem;
		.img_box {
			width: 7.4rem;
			height: 7.4rem;
			background-color: #d9d9d9;
			border-radius: var(--border-radius-full);
		}
		.content_box {
			display: flex;
			flex-direction: column;
			gap: 0.4rem;
			h4 {
				font-size: var(--font-s-xx-large);
				font-weight: var(--font-w-bold);
				line-height: 3rem;
				color: var(--color-base-white);
			}
			p {
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-light);
				color: var(--color-base-light);
				line-height: 1.9rem;
			}
		}
	}
}
</style>
